import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Seatingplan, TicketQuotaStatus } from "../../../../models";

@Component({
	selector: 'visual-ticket-quota-presentation',
	templateUrl: "./visual-ticket-quota.presentation.html",
	styles:[require("./visual-ticket-quota.presentation.scss")],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class VisualTicketQuotaPresentation {

	@Output() visualTicketQuotaButtonClicked = new EventEmitter<void>();

	@Input() private seatingplanName: string

	private _ticketQuotaStatus: TicketQuotaStatus[];

	@Input()
	set ticketQuotaStatus(ticketQuotaStatus: TicketQuotaStatus[]) {
		if (ticketQuotaStatus) {
			this._ticketQuotaStatus = ticketQuotaStatus;
		}
	}
}




// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-quota-collection/visual-ticket-quota/visual-ticket-quota.presentation.ts